<mat-dialog-content class="modal-header">
  <h2 mat-dialog-title>CANCELAR ACTIVIDAD</h2>
</mat-dialog-content>

<mat-dialog-content class="modal-body">
  <div class="content">
    <div class="form-horizontal">
      <div class="form-group">
        <label class="col-md-3 control-label">Actividad:</label>
        <div class="col-md-9">
          <mat-form-field appearance="outline" hideRequiredMarker>
            <mat-label>Actividad</mat-label>
            <input matInput [(ngModel)]="model.actividad" id="fechaCierre" name="fechaCierre" disabled />
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
  <div class="content">
    <div class="form-horizontal">
      <div class="form-group">
        <label class="col-md-3 control-label">Motivo:</label>
        <div class="col-md-9">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Comentarios</mat-label>
            <textarea matInput placeholder="Motivo" rows="5" [(ngModel)]="model.comentarios" name="comentarios"
              maxlength="2000" required></textarea>
            <!-- 
                  [disabled]="modelPersona.idEstado === 2" -->
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="modal-actions">
  <button type="submit" class="btn btn-naranja" (click)="Save()" [disabled]="!esValido()"
    mat-button><mat-icon>save</mat-icon> Guardar</button>
  <!-- [disabled]="!EsValido()" -->
  <!-- [mat-dialog-close]="data" -->
  <!-- <button type="submit" id="btnGuardar" class="btn btn-celeste" [disabled]="modelForm.invalid" (click)="guardar()">Submit</button> -->
  <button type="button" class="btn btn-naranja2" mat-button (click)="onNoClick()"><mat-icon>exit_to_app</mat-icon>
    Salir</button>
</mat-dialog-actions>